module.exports = __webpack_public_path__ + "static/media/elastos.aaa19501.jpg";